module.exports = __webpack_public_path__ + "img/download-ios.fd1ca71c.png";